import { forwardRef, InputHTMLAttributes, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { cln } from '../lib/utils';

interface Props extends InputHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  className?: string;
}

export const Select = forwardRef<HTMLSelectElement, PropsWithChildren<Props>>(
  ({ label, error, className, children, ...props }, ref) => {
    const { t } = useTranslation();
    const id = crypto.randomUUID();
    return (
      <span className={cln('select', className)}>
        {label && <label htmlFor={id}>{t(label)}</label>}
        <select ref={ref} id={id} {...props}>
          {children}
        </select>
        {error && <span className="text-label text-danger-500">{t(error)}</span>}
      </span>
    );
  },
);

Select.displayName = 'Select';
